<p-avatar
  [image]="getAvatarImage()"
  [label]="getAvatarLabel()"
  [styleClass]="!image ? getAvatarColor() + ' text-white' : ''"
  [size]="size"
  shape="circle"
  class="cursor-pointer"
/>
